import React from "react";

const InputCheckbox = (props) => {
  const {
    input,
    meta: { touched, error, visited },
  } = props;

  return (
    <>
      <label
        className={`flex ${props.className ? props.className : ""} ${
          props.disabled ? "disabled" : ""
        }`}
      >
        <input
          {...input}
          type="checkbox"
          required={props.required}
          disabled={props.disabled}
          className={`checkbox-input opacity-0 w-0 h-0 ${
            touched && error ? "error" : ""
          }`}
        />

        <span
          className={`checkbox-control flex-none w-5 h-5 p-1 mr-2 border-gray-light border rounded-4px bg-white ${
            props.required ? "is-required" : ""
          }`}
        >
          <svg
            className=""
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            aria-hidden="true"
            focusable="false"
          >
            <path
              fill="none"
              stroke="currentColor"
              strokeWidth="3"
              d="M1.73 12.91l6.37 6.37L22.79 4.59"
            />
          </svg>
        </span>

        <span
          className={`block Form-label label ${props.spanClassName} ${
            props.required ? "is-required" : ""
          }`}
        >
          {typeof props.label === "string" ? (
            <span dangerouslySetInnerHTML={{ __html: props.label }}></span>
          ) : (
            props.label
          )}
        </span>
      </label>

      {props.required && (
        <div className={visited && error ? "" : "hidden"}>
          <div className="text-red-brand text-sm">{error}</div>
        </div>
      )}
    </>
  );
};

InputCheckbox.defaultProps = {
  required: undefined,
  disabled: undefined,
};

export default InputCheckbox;
